export default Object.freeze({
  Anyone: 'Anyone',
  ManagerOnly: 'ManagerOnly',
  NotSet: 'NotSet',
});
